/**
 * `/no-access` — authenticated, but zero grants (SPEC §9.1).
 *
 * "Shows who to contact." A signed-in user staring at an empty portal will
 * assume it is broken, and the fix is an administrator granting them a role —
 * something they cannot discover from an empty page.
 */

import { Mail } from 'lucide-react'

import { useMe } from '../lib/session'

export function NoAccess() {
  const me = useMe()

  return (
    <div className="mx-auto max-w-lg py-12 text-center">
      <h1 className="text-[length:var(--text-lg)] font-semibold tracking-tight">
        No reports are shared with you yet
      </h1>
      <p className="mt-2 text-[length:var(--text-sm)] text-[var(--color-ink-muted)]">
        You are signed in
        {me !== undefined && (
          <>
            {' as '}
            <span className="numeric">{me.user.upn}</span>
          </>
        )}
        , but no role grants you access to a department yet. Access is granted per department by
        an administrator.
      </p>
      <a
        href="mailto:it@sunorchard.com?subject=Reporting%20Portal%20access"
        className="mt-5 inline-flex items-center gap-2 rounded-[var(--radius-md)] border border-[var(--color-rule)] bg-[var(--color-surface-raised)] px-3 py-1.5 text-[length:var(--text-sm)]"
      >
        <Mail aria-hidden className="size-4" />
        Request access
      </a>
    </div>
  )
}
